import { cn } from '@/lib/utils';
import { columnLabelClass } from '@/components/ui/typography.ts';

/**
 * Kształt obu tabel z grupy „Płatności" — rat i wpłat. Karty stoją obok siebie
 * na tym samym ekranie, więc szerokości kolumn, pasek nagłówków i zachowanie
 * przy wąskiej karcie muszą schodzić z jednego miejsca.
 */

export const columnHeaderCellClass = cn('pb-2.5', columnLabelClass);

// Kolumna akcji ma stałą szerokość także wtedy, gdy wiersz nie ma akcji
// (rata opłacona) — inaczej kwoty w sąsiednich wierszach by się rozjechały.
export const installmentsGrid =
  'grid grid-cols-[1fr_auto_26px] gap-x-4 px-4 @min-[600px]:grid-cols-[1fr_120px_130px_120px_40px] @min-[600px]:gap-x-0 @min-[600px]:px-7';
export const paymentsGrid =
  'grid grid-cols-[1fr_auto_26px] gap-x-4 px-4 @min-[600px]:grid-cols-[150px_1fr_130px_40px] @min-[600px]:gap-x-0 @min-[600px]:px-7';

/**
 * Poniżej progu wiersz tabeli składa się na dwie kolumny: opis po lewej, kwoty
 * i status po prawej, a menu wiersza stoi obok nich na całą wysokość. Pasek nagłówków wtedy znika — nie ma jak podpisać komórek
 * ustawionych w dwóch rzędach. Próg mierzy kartę (`@container`), bo kolumna
 * treści bywa wąska także na szerokim ekranie, gdy obok stoi panel boczny.
 */
export const stackedCell = {
  topLeft:
    'min-w-0 wrap-anywhere @max-[600px]:col-start-1 @max-[600px]:row-start-1 @max-[600px]:pb-0',
  bottomLeft:
    'min-w-0 wrap-anywhere @max-[600px]:col-start-1 @max-[600px]:row-start-2 @max-[600px]:pt-0.5',
  topRight:
    '@max-[600px]:col-start-2 @max-[600px]:row-start-1 @max-[600px]:pb-0',
  bottomRight:
    '@max-[600px]:col-start-2 @max-[600px]:row-start-2 @max-[600px]:pt-0.5',
  actions:
    'flex justify-end @max-[600px]:col-start-3 @max-[600px]:row-span-2 @max-[600px]:row-start-1',
};

/**
 * Stopka sumy wyrównana do prawej krawędzi kwot, a nie karty: wcięcie karty
 * plus kolumna akcji (26 px i odstęp wąsko, 40 px szeroko).
 */
export const tableTotalRowClass = 'pr-[58px] @min-[600px]:pr-[68px]';

// W ratach za kwotą stoi jeszcze kolumna statusu (120 px).
export const installmentsTotalRowClass = 'pr-[58px] @min-[600px]:pr-[188px]';

/** Nagłówek karty: tytuł i dopisek nad tabelą. */
export const tableCardHeaderClass =
  '@min-[600px]:px-7 flex flex-wrap items-baseline gap-2.5 px-4 pb-3.5 pt-5';

/** Miejsce po tabeli, gdy nie ma czego pokazać — wcięcia karty bez wiersza. */
export const tableCardEmptyClass = '@min-[600px]:px-7 px-4 pb-6';
